module.exports = __webpack_public_path__ + "static/media/janio_logo (no tagline).814ebe72.png";